import React, { FC } from 'react';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';
import TableDocuments from '../../components/core/TableDocuments/TableDocuments';
import './RepositoryContent';

interface RepositoryContentProps {}
const RepositoryContent: React.FC<RepositoryContentProps> = () => {
  return(
  <div className="RepositoryContent">
        <PrimaryNavigation />
        <TableDocuments></TableDocuments>
        {/* <div className="table-container">
         <TableDocuments></TableDocuments>
        </div> */}
    </div>);
}

export default RepositoryContent;
